var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _circle2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _circle3, _circle4, _circle5, _circle6, _path22, _path23, _path24, _path25, _circle7, _path26, _path27, _path28, _path29, _path30, _path31, _g, _path32, _path33, _path34, _rect, _g2, _path35, _path36, _path37, _path38, _path39, _circle8, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _rect2, _path47, _path48, _path49, _path50;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 663.17,
    height: 762,
    viewBox: "0 0 663.17 762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 459.65,
    y1: 738.32,
    x2: 459.65,
    y2: 284.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 600.72,
    y1: 403,
    x2: 600.72,
    y2: 323.66,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 600.72,
    y1: 550.56,
    x2: 600.72,
    y2: 471.22,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 600.72,
    y1: 697.13,
    x2: 600.72,
    y2: 617.79,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 665.06,
    y1: 369.67,
    x2: 665.06,
    y2: 351.79,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 479.65,
    y1: 365.1,
    x2: 479.65,
    y2: 234.63,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 614.02,
    y1: 339.34,
    x2: 614.02,
    y2: 310.82,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 87.62,
    y1: 142.68,
    x2: 87.62,
    y2: 34.45,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 347.57,
    y1: 491.51,
    x2: 347.57,
    y2: 211.68,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 116.39,
    y1: 708.74,
    x2: 116.39,
    y2: 419.27,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 499.2,
    y1: 831,
    x2: 499.2,
    y2: 777.74,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 347.16,
    y1: 831,
    x2: 347.16,
    y2: 777.74,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 370.62,
    y1: 206.37,
    x2: 370.62,
    y2: 102.59,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 351.42,
    y1: 198.2,
    x2: 351.42,
    y2: 69,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 355.36,
    y1: 108.01,
    x2: 355.36,
    y2: 84.91,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 361.95,
    y1: 198.2,
    x2: 361.95,
    y2: 69,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 397.75,
    y1: 491.51,
    x2: 397.75,
    y2: 211.68,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 449.38,
    y1: 383.47,
    x2: 449.38,
    y2: 253.01,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 583.76,
    y1: 357.71,
    x2: 583.76,
    y2: 329.2,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 87.62,
    y1: 165.87,
    x2: 87.62,
    y2: 119.49,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 96.33,
    y1: 708.74,
    x2: 96.33,
    y2: 484.55,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 190.29,
    y1: 708.74,
    x2: 190.29,
    y2: 419.27,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 522.82,
    y1: 831,
    x2: 522.82,
    y2: 777.74,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 375.07,
    y1: 831,
    x2: 375.07,
    y2: 777.74,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 259.45,
    y1: 270.72,
    x2: 259.45,
    y2: 260.36,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 82.08,
    y1: 254.09,
    x2: 82.08,
    y2: 165.45,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 779.72,
    y1: 363.2,
    x2: 779.72,
    y2: 235.39,
    xlinkHref: "#a"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "maintenance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b0bec5",
    d: "M333.04 279.64h9.46v6.31h-9.46zm12.61 0h9.46v6.31h-9.46zm12.62 0h9.46v6.31h-9.46zm12.61 0h9.46v6.31h-9.46zm12.62 0h9.46v6.31h-9.46zm12.62 0h9.46v6.31h-9.46zm12.61 0h9.46v6.31h-9.46zm12.62 0h9.46v6.31h-9.46zm12.61 0h9.46v6.31h-9.46zm12.62 0h9.46v6.31h-9.46z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M256.14 284.02h407.03v454.29H256.14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M262.87 587.33h393.58v141.09H262.87z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M295.17 620.8h15.25v72.29h-15.25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M325.28 620.8h15.25v72.29h-15.25z",
    opacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M355.39 620.8h15.25v72.29h-15.25z",
    opacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M385.5 620.8h15.25v72.29H385.5zm30.11 0h15.25v72.29h-15.25z",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M445.72 620.8h15.25v72.29h-15.25z",
    opacity: 0.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M475.82 620.8h15.25v72.29h-15.25z",
    opacity: 0.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 600.72,
    cy: 656.48,
    r: 36.8,
    fill: "#727cf5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M262.87 440.75h393.58v141.09H262.87z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M295.17 474.22h15.25v72.29h-15.25z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M325.28 474.22h15.25v72.29h-15.25z",
    opacity: 0.7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M355.39 474.22h15.25v72.29h-15.25z",
    opacity: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M385.5 474.22h15.25v72.29H385.5zm30.11 0h15.25v72.29h-15.25z",
    opacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M445.72 474.22h15.25v72.29h-15.25z",
    opacity: 0.4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M475.82 474.22h15.25v72.29h-15.25z",
    opacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 600.72,
    cy: 509.91,
    r: 36.8,
    fill: "#727cf5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M262.87 294.18h393.58v141.09H262.87z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M295.17 327.64h15.25v72.29h-15.25z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M325.28 327.64h15.25v72.29h-15.25z",
    opacity: 0.7
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M355.39 327.64h15.25v72.29h-15.25z",
    opacity: 0.6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M385.5 327.64h15.25v72.29H385.5zm30.11 0h15.25v72.29h-15.25z",
    opacity: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M445.72 327.64h15.25v72.29h-15.25z",
    opacity: 0.4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M475.82 327.64h15.25v72.29h-15.25z",
    opacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 600.72,
    cy: 363.33,
    r: 39.67,
    fill: "url(#b)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 600.72,
    cy: 510.89,
    r: 39.67,
    fill: "url(#c)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 600.72,
    cy: 657.46,
    r: 39.67,
    fill: "url(#d)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 600.72,
    cy: 363.33,
    r: 36.8,
    fill: "#727cf5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M740.22 369.67H594.86a5 5 0 0 1-5-5v-7.92a5 5 0 0 1 5-5h145.36z",
    transform: "translate(-268.41 -69)",
    fill: "url(#e)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M471.81 298.56H329.08a5 5 0 0 1-5-5v-4.77a5 5 0 0 1 5-5h142.73z",
    fill: "#b0bec5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M369.8 272.22l105 92.88 122-25.77-9.45-27.49L492.81 323l-94.59-83a21.49 21.49 0 0 0-31.72 3.74 21.49 21.49 0 0 0 3.3 28.48z",
    transform: "translate(-268.41 -69)",
    fill: "url(#f)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M596.74 339.33s31.12.86 42.62-16.32-52.07-11.17-52.07-11.17z",
    transform: "translate(-268.41 -69)",
    fill: "url(#g)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.62,
    cy: 88.56,
    r: 54.12,
    fill: "url(#h)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M333.7 216.83s-69.5 46.8-51.85 191.48a126.66 126.66 0 0 1-4.46 52.07l-9 29.6s152.9 3.44 157.19 0c2.66-2.13.59-56.65-6.87-132.28-4.57-46.33 9.76-110.78-39.51-146z",
    transform: "translate(-268.41 -69)",
    fill: "url(#i)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M157.19 419.27l67.86 143.45 7.73 146.02h-48.1l-20.62-151.18-41.23-73.01L81.6 708.74H33.5L48.1 542.1 0 420.99l157.19-1.72z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M501.2 777.74l14.6 22.33s49 18.9 27.49 30.92h-93.63v-53.25z",
    transform: "translate(-268.41 -69)",
    fill: "url(#k)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M349.16 777.74l14.6 22.33s49 18.9 27.49 30.92h-93.63v-53.25z",
    transform: "translate(-268.41 -69)",
    fill: "url(#l)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M356.89 102.59a53.85 53.85 0 0 0-26.66 7 54.11 54.11 0 0 1 48.17 96.75 54.12 54.12 0 0 0-21.51-103.78z",
    transform: "translate(-268.41 -69)",
    fill: "url(#m)",
    opacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M421.82 69l-15.06 23c-5.41 8.27-13.27 17.66-23 15.74-4.52-.89-8.14-4.15-11.75-7-11.81-9.38-26.42-15.74-41.5-15.83s-30.51 6.7-39 19.15c-6.29 9.19-8.46 20.53-9.7 31.59-2.49 22.12 0 48.23 18.47 60.65a8.68 8.68 0 0 0 5.24 1.89c2-.13 3.62-1.4 5.12-2.66 23.12-19.37 36-50.87 63.84-64.17 12.29-5.86 30.17-5.91 40.08-15.87 14.6-14.64-1.56-33.02 7.26-46.49z",
    transform: "translate(-268.41 -69)",
    fill: "url(#n)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366 100.74c3.61 2.87 7.22 6.13 11.75 7a13 13 0 0 0 5.56-.11c-4.31-1-7.8-4.15-11.29-6.91-11.81-9.38-26.42-15.74-41.5-15.83-1.06 0-2.11 0-3.17.09 14.1.83 27.65 7.02 38.65 15.76z",
    transform: "translate(-268.41 -69)",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.82 69l-8.69 13.29c.83 10.93 5.63 23-4.55 33.2-9.92 10-27.8 10-40.08 15.87-27.87 13.3-40.73 44.81-63.84 64.17a16.5 16.5 0 0 1-2.56 1.84 6.71 6.71 0 0 0 3.45.82c2-.13 3.62-1.4 5.12-2.66 23.12-19.37 36-50.87 63.84-64.17 12.29-5.86 30.17-5.91 40.08-15.87 14.57-14.64-1.59-33.02 7.23-46.49z",
    transform: "translate(-268.41 -69)",
    fill: "url(#p)"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M418.74 357.71c-4.57-46.33 9.76-110.78-39.51-146l-10.43 1.18c47.35 35.48 33.4 99 37.92 144.84 7.46 75.63 9.54 130.15 6.87 132.28-1.31 1-16.44 1.46-36.83 1.52 26.23.07 47.3-.27 48.86-1.52 2.65-2.15.57-56.67-6.88-132.3z",
    transform: "translate(-268.41 -69)",
    fill: "url(#q)",
    opacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M339.54 290.59l105 92.88 122-25.77-9.54-27.48-94.49 11.17-94.59-83a21.49 21.49 0 0 0-31.72 3.74 21.49 21.49 0 0 0 3.34 28.46z",
    transform: "translate(-268.41 -69)",
    fill: "url(#r)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M566.48 357.71s31.12.86 42.62-16.32-52.1-11.17-52.1-11.17z",
    transform: "translate(-268.41 -69)",
    fill: "url(#s)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64.42,
    y: 119.49,
    width: 46.38,
    height: 46.38,
    rx: 20.47,
    ry: 20.47,
    fill: "url(#t)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M113.38 484.55L72.15 708.74h9.45l38.91-211.57-7.13-12.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M225.05 562.72l-67.86-143.45-9.4.1 67.81 143.35 7.73 146.02h9.45l-7.73-146.02z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M515.8 800.08l-14.6-22.33h-4.3l14.6 22.33S560.47 819 539 831h4.29c21.47-12-27.49-30.92-27.49-30.92z",
    transform: "translate(-268.41 -69)",
    fill: "url(#w)",
    opacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M368.06 800.08l-14.6-22.33h-4.29l14.6 22.33s49 18.9 27.49 30.92h4.29c21.45-12-27.49-30.92-27.49-30.92z",
    transform: "translate(-268.41 -69)",
    fill: "url(#x)",
    opacity: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M304.19 265.68l-1.83-5.32-87.65 10.36 89.48-5.04z",
    opacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M43.17 220.58l29.19-55.13L121 183.83l-48.64 70.26-29.19-33.51z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M103.72 208.09l102.09 90.34 118.63-25.06-9.19-26.73-91.9 10.86-92-80.76a20.9 20.9 0 0 0-30.85 3.64 20.9 20.9 0 0 0 3.22 27.71zm220.72 65.27s30.27.84 41.45-15.87-50.64-10.86-50.64-10.86z",
    fill: "#ca7070"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.32,
    cy: 96.58,
    r: 52.63,
    fill: "#ca7070"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M68.59 154.22S.99 199.74 18.16 340.46a123.19 123.19 0 0 1-4.34 50.65L5.1 419.9s148.71 3.34 152.89 0c2.59-2.07.57-55.1-6.68-128.66-4.44-45.06 9.49-107.75-38.43-142z",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#5caade",
    d: "M157.99 418.22l66 139.52 7.51 142.02h-46.78l-20.05-147.03-40.1-71.02-40.1 218.05H37.68l14.2-162.07L5.1 419.89l152.89-1.67z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M231.51 699.76l14.2 21.72s47.62 18.38 26.73 30.08h-91.06v-51.8zm-147.92 0l14.2 21.72s47.62 18.38 26.73 30.08H33.51v-51.8z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M91.16 43.11a52.37 52.37 0 0 0-25.93 6.84A52.63 52.63 0 0 1 112.08 144 52.64 52.64 0 0 0 91.16 43.07z",
    fill: "#fff",
    opacity: 0.2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M154.3 10.44l-14.64 22.39c-5.26 8-12.9 17.17-22.33 15.31-4.4-.87-7.91-4-11.42-6.83-11.5-9.12-25.7-15.31-40.32-15.4s-29.67 6.52-38 18.62c-6.11 8.93-8.22 20-9.44 30.73-2.42 21.51 0 46.91 18 59a8.45 8.45 0 0 0 5.09 1.83c1.9-.13 3.52-1.36 5-2.59 22.48-18.83 35-49.48 62.1-62.41 11.95-5.7 29.34-5.75 39-15.43 14.11-14.24-1.61-32.12 6.96-45.22z",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M100.05 41.31c3.51 2.79 7 6 11.42 6.83a12.69 12.69 0 0 0 5.41-.1c-4.19-1-7.59-4-11-6.72C94.41 32.19 80.21 26 65.59 25.91c-1 0-2.05 0-3.08.09 13.63.79 26.78 6.76 37.54 15.31zm54.25-30.87l-8.46 12.93c.8 10.63 5.48 22.34-4.43 32.29-9.65 9.68-27 9.73-39 15.43-27.11 12.93-39.61 43.58-62.1 62.41a16 16 0 0 1-2.49 1.79 6.52 6.52 0 0 0 3.35.8c1.9-.13 3.52-1.36 5-2.59 22.48-18.83 35-49.48 62.1-62.41 11.95-5.7 29.34-5.75 39-15.43 14.18-14.24-1.54-32.12 7.03-45.22zm-2.99 280.79c-4.44-45.06 9.49-107.75-38.43-142l-10.14 1.15c46.05 34.51 32.48 96.31 36.88 140.88 7.25 73.56 9.27 126.59 6.68 128.66-1.27 1-16 1.42-35.82 1.48 25.52.07 46-.27 47.52-1.48 2.59-2.1.59-55.12-6.69-128.69z",
    opacity: 0.2,
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M74.28 226l102.09 90.3L295 291.24l-9.19-26.73-91.9 10.86-92-80.76a20.9 20.9 0 0 0-30.85 3.64A20.9 20.9 0 0 0 74.28 226zM295 291.23s30.27.84 41.45-15.87-50.64-10.86-50.64-10.86z",
    fill: "#ca7070"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67.76,
    y: 126.65,
    width: 45.11,
    height: 45.11,
    rx: 20.47,
    ry: 20.47,
    fill: "#ca7070"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M115.38 481.71l-40.1 218.05h9.19l37.84-205.77-6.93-12.28zm108.61 76.03l-66-139.52-9.15.1 65.96 139.42 7.51 142.02h9.19l-7.51-142.02zm21.72 163.75l-14.2-21.72h-4.18l14.2 21.72s47.62 18.38 26.73 30.08h4.18c20.89-11.7-26.73-30.08-26.73-30.08zm-143.69 0l-14.2-21.72h-4.23l14.2 21.72s47.62 18.38 26.73 30.08h4.18c20.89-11.7-26.68-30.08-26.68-30.08zm198.93-452.65l-1.77-5.17-85.25 10.07 87.02-4.9z",
    opacity: 0.2,
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M47.09 224.97l28.38-53.61 47.31 17.87-47.31 68.33-28.38-32.59z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M730.24 354.36l86-116.94a5 5 0 0 1 7-1.06l4 2.95a5 5 0 0 1 1.06 7l-86 116.94z",
    transform: "translate(-268.41 -69)",
    fill: "url(#A)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M463.54 286.61l84.54-115a5 5 0 0 1 7-1.06l.41.3a5 5 0 0 1 1.06 7l-84.54 115z",
    fill: "#b0bec5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.b427d9ecf0f2faf23d0ccb5150d8f921.svg";
export { ForwardRef as ReactComponent };